import MobileViewModal from './MobileViewModal';

export default MobileViewModal;
